// Angular
import { NgModule } from '@angular/core';


import { CommonModule } from '@angular/common';
import { FieldErrorDisplayComponent } from '../../components/validate-form/field-error-display.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
    imports: [
        CommonModule,
        AlertModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        FieldErrorDisplayComponent
    ],
    exports: [
        FieldErrorDisplayComponent
    ],
    providers: [
    ]
})
export class FieldErrorDisplayModule { }
